import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang];

  const navLinks = [
    { key: 'home', path: '/' },
    { key: 'about', path: '/about' },
    { key: 'products', path: '/products' },
    { key: 'quality', path: '/quality' },
    { key: 'whyDifferent', path: '/why-different' },
    { key: 'quote', path: '/quote' },
    { key: 'contact', path: '/contact' },
  ];

  const certifs = ['Agriculture Biologique', 'Ecocert', 'Fair Trade', 'USDA Organic'];

  return (
    <footer className="bg-[#2B2016]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <span
                style={{
                  fontFamily: '"Cormorant Garamond", serif',
                  letterSpacing: '0.32em',
                  fontSize: '1.2rem',
                  fontWeight: 500,
                  color: '#FAF7F2',
                }}
              >
                VANELYS
              </span>
              <div
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '0.42rem',
                  letterSpacing: '0.22em',
                  color: '#C9A84C',
                  marginTop: '3px',
                  textTransform: 'uppercase',
                  fontWeight: 500,
                }}
              >
                VENUE DU PARADIS
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">{t.footer.tagline}</p>
            <div className="w-8 h-px bg-[#C9A84C] mt-6" />
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#C9A84C] text-[10px] uppercase tracking-[0.28em] font-semibold mb-5">
              {t.footer.navigation}
            </h4>
            <ul className="space-y-2">
              {navLinks.map(({ key, path }) => (
                <li key={key}>
                  <Link to={path} className="text-white/50 hover:text-white/90 text-sm transition-colors">
                    {t.nav[key]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#C9A84C] text-[10px] uppercase tracking-[0.28em] font-semibold mb-5">
              {t.footer.contact}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <MapPin size={13} className="text-[#C9A84C] mt-0.5 shrink-0" />
                <span className="text-white/50 text-sm">Nice, France</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail size={13} className="text-[#C9A84C] mt-0.5 shrink-0" />
                <a href="mailto:Contact@vanelys.fr" className="text-white/50 hover:text-[#C9A84C] text-sm transition-colors">
                  Contact@vanelys.fr
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone size={13} className="text-[#C9A84C] mt-0.5 shrink-0" />
                <div className="flex flex-col gap-1">
                  <a href="tel:+33789015050" className="text-white/50 hover:text-[#C9A84C] text-sm transition-colors">+33 7 89 01 50 50</a>
                  <a href="tel:+33610257950" className="text-white/50 hover:text-[#C9A84C] text-sm transition-colors">+33 6 10 25 79 50</a>
                </div>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div>
            <h4 className="text-[#C9A84C] text-[10px] uppercase tracking-[0.28em] font-semibold mb-5">
              {t.footer.certif}
            </h4>
            <div className="flex flex-col gap-2">
              {certifs.map((c) => (
                <div key={c} className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-[#C9A84C]" />
                  <span className="text-white/50 text-xs">{c}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;